(function () {
  'use strict';
  var scenes = new Map();
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var queued = false;
  function frame() {
    queued = false;
    var active = false;
    scenes.forEach(function (scene, root) {
      if (!root.isConnected) { scenes.delete(root); return; }
      if (!scene.pinned) return;
      var rect = root.getBoundingClientRect();
      var travel = root.offsetHeight - scene.pin.offsetHeight;
      var progress = Math.max(0, Math.min(1, (scene.top - rect.top) / Math.max(1, travel)));
      scene.show(Math.min(scene.panels.length - 1, Math.floor(progress * scene.panels.length)));
      if (rect.top <= scene.top + 2 && rect.bottom > scene.top + scene.pin.offsetHeight) active = true;
    });
    document.body.classList.toggle('v5-journey-active', active);
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(frame); } }
  function layout() {
    var header = document.querySelector('[data-v3-header]');
    var top = header ? Math.ceil(header.getBoundingClientRect().height) + 8 : 12;
    scenes.forEach(function (scene, root) {
      scene.top = top;
      scene.pinned = !motion.matches && window.innerHeight >= 650 && !(window.Shopify && window.Shopify.designMode);
      root.classList.toggle('is-pinned', scene.pinned);
      root.style.setProperty('--v5-pin-top', top + 'px');
      root.style.height = scene.pinned ? (Math.max(0, window.innerHeight - top - 12) + scene.panels.length * Math.max(360, window.innerHeight * .68)) + 'px' : '';
      if (scene.pinned && scene.pin.scrollHeight > scene.pin.clientHeight + 3) {
        scene.pinned = false; root.classList.remove('is-pinned'); root.style.height = '';
      }
      var hint = root.querySelector('.v5-journey-hint');
      if (hint) hint.hidden = !scene.pinned;
    });
    schedule();
  }

  function initFaq(scope) {
    var roots = Array.from(scope.querySelectorAll('[data-v53-faq]'));
    if (scope.matches && scope.matches('[data-v53-faq]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (root.dataset.v53FaqReady === '1') return;
      root.dataset.v53FaqReady = '1';
      var items = Array.from(root.querySelectorAll('details.v4-faq-item'));
      var foundOpen = false;
      items.forEach(function (item) {
        if (item.open) {
          if (foundOpen) item.open = false;
          foundOpen = true;
        }
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });
  }

  function initReviewFallback(scope) {
    var roots = Array.from(scope.querySelectorAll('[data-v53-reviews]'));
    if (scope.matches && scope.matches('[data-v53-reviews]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (root.dataset.v53ReviewsReady === '1') return;
      root.dataset.v53ReviewsReady = '1';
      var fallback = root.querySelector('[data-v53-reviews-empty]');
      var widget = root.querySelector('#judgeme_product_reviews, .v53-judgeme-legacy');
      if (!fallback || !widget) return;
      function hasContent() {
        var review = widget.querySelector('.jdgm-rev, .jdgm-rev-widg, .jdgm-row-stars, .jdgm-write-rev-link, .jdgm-rev-widg__summary');
        var text = (widget.textContent || '').replace(/\s+/g, ' ').trim();
        var meaningful = !!review || text.length > 30;
        fallback.hidden = meaningful;
      }
      hasContent();
      var observer = new MutationObserver(hasContent);
      observer.observe(widget, { childList: true, subtree: true, characterData: true });
      window.setTimeout(hasContent, 1200);
      window.setTimeout(hasContent, 3500);
    });
  }


  function initProductReviewPolish(scope) {
    var roots = Array.from(scope.querySelectorAll('[data-v55-reviews]'));
    if (scope.matches && scope.matches('[data-v55-reviews]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (root.dataset.v55ReviewsReady === '1') return;
      root.dataset.v55ReviewsReady = '1';

      function cleanReviewUI() {
        /* Judge.me media is optional on this storefront. Make that explicit if the field is rendered. */
        Array.from(root.querySelectorAll('input[type="file"]')).forEach(function (input) {
          input.required = false;
          input.removeAttribute('required');
          input.setAttribute('aria-required', 'false');
          var label = input.id ? root.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
          if (!label) label = input.closest('label');
          if (!label) {
            var field = input.closest('.jdgm-form__fieldset, .jdgm-form-group, fieldset, div');
            if (field) label = field.querySelector('label, legend');
          }
          if (label) {
            var text = (label.textContent || '').trim();
            if (/photo|image|media|video/i.test(text) && !/optional/i.test(text)) label.textContent = text + ' (optional)';
          }
        });

        /* PDP is for this product only: hide any store/shopping-experience tabs injected into this section. */
        Array.from(root.querySelectorAll('button, a, [role="tab"], summary')).forEach(function (el) {
          var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
          if (/^(store reviews?|shopping experience(?: review)?s?)$/i.test(text)) el.hidden = true;

          /* Judge.me can inject its own green inline/widget styles after theme CSS loads.
             Brand the actual rendered Write a review control with inline !important values. */
          if (/^write a review$/i.test(text)) {
            el.style.setProperty('background', 'linear-gradient(135deg,#6843ef,#8a5cff)', 'important');
            el.style.setProperty('background-color', '#7047e8', 'important');
            el.style.setProperty('border-color', '#6843ef', 'important');
            el.style.setProperty('color', '#fff', 'important');
            el.style.setProperty('border-radius', '12px', 'important');
            el.style.setProperty('box-shadow', '0 9px 22px rgba(104,67,239,.18)', 'important');
            el.style.setProperty('font-weight', '800', 'important');
          }
        });

        /* V5.8: Judge.me can render stars as icon fonts, SVGs or via widget variables.
           Force every rating implementation to the Craft Logic purple. */
        ['--jdgm-primary-color', '--jdgm-star-color', '--jdgm-review-star-color', '--jdgm-color-primary', '--jdgm-color-star'].forEach(function (name) {
          root.style.setProperty(name, '#7047e8', 'important');
        });
        Array.from(root.querySelectorAll('.jdgm-widget, .jdgm-review-widget, [class*=\"jdgm\"]')).forEach(function (node) {
          ['--jdgm-primary-color', '--jdgm-star-color', '--jdgm-review-star-color', '--jdgm-color-primary', '--jdgm-color-star'].forEach(function (name) {
            node.style.setProperty(name, '#7047e8', 'important');
          });
        });
        Array.from(root.querySelectorAll('.jdgm-star, .jdgm-stars, .jdgm-rev__rating, .jdgm-row-stars, [class*=\"jdgm-star\"]')).forEach(function (star) {
          star.style.setProperty('color', '#7047e8', 'important');
          star.style.setProperty('-webkit-text-fill-color', '#7047e8', 'important');
          Array.from(star.querySelectorAll('svg, path, polygon')).forEach(function (shape) {
            shape.style.setProperty('color', '#7047e8', 'important');
            shape.style.setProperty('fill', '#7047e8', 'important');
            if (shape.tagName.toLowerCase() !== 'svg') shape.style.setProperty('stroke', '#7047e8', 'important');
          });
        });
      }

      if (!document.getElementById('v59-judgeme-star-override')) {
        var judgeStyle = document.createElement('style');
        judgeStyle.id = 'v59-judgeme-star-override';
        judgeStyle.textContent = 'html body .v55-reviews .jdgm-widget .jdgm-star,html body .v55-reviews .jdgm-widget .jdgm-star:before,html body .v55-reviews .jdgm-widget .jdgm-star::before,html body .v55-reviews .jdgm-widget .jdgm-star.jdgm--on:before,html body .v55-reviews .jdgm-widget .jdgm-star.jdgm--half:before,html body .v55-reviews .jdgm-widget [class*=\"star\" i],html body .v55-reviews .jdgm-widget [class*=\"star\" i]::before{color:#7047e8!important;-webkit-text-fill-color:#7047e8!important}html body .v55-reviews .jdgm-widget [class*=\"star\" i] svg,html body .v55-reviews .jdgm-widget [class*=\"star\" i] svg *{color:#7047e8!important;fill:#7047e8!important;stroke:#7047e8!important}';
        document.head.appendChild(judgeStyle);
      }

      cleanReviewUI();
      var observer = new MutationObserver(cleanReviewUI);
      observer.observe(root, { childList: true, subtree: true });
      window.setTimeout(cleanReviewUI, 1000);
      window.setTimeout(cleanReviewUI, 3000);
    });
  }

  function init(scope) {
    var roots = Array.from(scope.querySelectorAll('[data-v5-journey]'));
    if (scope.matches && scope.matches('[data-v5-journey]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (scenes.has(root)) return;
      var panels = Array.from(root.querySelectorAll('[data-v5-panel]'));
      var buttons = Array.from(root.querySelectorAll('[data-v5-step]'));
      if (!panels.length) return;
      var scene = { pin: root.querySelector('.v5-journey-pin'), panels: panels, top: 0, pinned: false, current: -1 };
      scene.show = function (index) {
        if (scene.current === index) return;
        scene.current = index;
        panels.forEach(function (panel, i) { panel.hidden = i !== index; panel.classList.toggle('is-current', i === index); });
        buttons.forEach(function (button, i) { button.setAttribute('aria-pressed', String(i === index)); });
      };
      function select(index) {
        if (scene.pinned) {
          var start = root.getBoundingClientRect().top + window.scrollY - scene.top;
          var travel = root.offsetHeight - scene.pin.offsetHeight;
          window.scrollTo({ top: start + (index + .3) / panels.length * travel, behavior: 'instant' });
        }
        scene.show(index);
      }
      buttons.forEach(function (button, i) {
        button.addEventListener('click', function () { select(i); });
        button.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowRight') next = (i + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (i + buttons.length - 1) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next !== undefined) { event.preventDefault(); buttons[next].focus({ preventScroll: true }); select(next); }
        });
      });
      root.addEventListener('shopify:block:select', function (event) { var panel = event.target.closest('[data-v5-panel]'); var index = panels.indexOf(panel); if (index >= 0) select(index); });
      // Preload all five images when the scene approaches, avoiding blank swaps.
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          panels.forEach(function (panel) { var img = panel.querySelector('img'); if (img) img.loading = 'eager'; });
          observer.disconnect();
        }
      }, { rootMargin: '700px' });
      observer.observe(root);
      scene.observer = observer;
      scenes.set(root, scene);
      root.classList.add('is-enhanced');
      scene.show(0);
    });
    initFaq(scope);
    initReviewFallback(scope);
    initProductReviewPolish(scope);
    layout();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', layout, { passive: true });
  window.addEventListener('pageshow', layout);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
  if (motion.addEventListener) motion.addEventListener('change', layout);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { scenes.forEach(function (scene, root) { if (event.target.contains(root)) { scene.observer.disconnect(); scenes.delete(root); } }); schedule(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
